/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@uniiverse/library/components/button/index';

import Card from '../../card/index';
import DiscoverEventsIcon from '../../../assets/discover-events.svg';

import style from './index-module.css';

type Props = {
  data: ProfileQuery,
  currentUser: Object
};

const NoUpcomingEvents: Function = (props: Props) => {
  const { data: { profile }, currentUser } = props;
  const userOwnsProfile = currentUser && currentUser.id === profile.id;

  const redirectToDiscover: Function = () => {
    window.location.href = '/explore';
    return false;
  };

  return (
    <Card className={style.emptyList}>
      <div className={style.icon}>
        <DiscoverEventsIcon />
      </div>
      {
        userOwnsProfile ?
          <FormattedMessage
            id="profile.owner-no-upcoming-events"
            defaultMessage="You don't have any upcoming events."
          /> :
          <FormattedMessage
            id="profile.no-upcoming-events"
            defaultMessage="{name} doesn't have any upcoming events."
            values={{ name: profile.firstName }}
          />
      }
      <br />
      <div className={style.discoverButton}>
        <Button type="outline" size="default" onClick={redirectToDiscover}>
          <FormattedMessage id="profile.discover-events" defaultMessage="Discover other events" />
        </Button>
      </div>
    </Card>
  );
};

export default NoUpcomingEvents;



// WEBPACK FOOTER //
// ./src/components/profile/no-upcoming-events/index.js